/* 配送日時指定（カレンダーマスター richDelivery.js）の移設。
 *
 * アプリは name="checkout" ボタンの直前へ .calendarMaster__autoInstall
 * （配送希望日・時間帯）と .calendarMaster__placementAutoInstall（置き配）を
 * ページロード時に自動挿入する（挿入位置はアプリ実装にハードコードされており
 * テーマ側から指定できない）。本スクリプトはそれらをフッター左の専用スロット
 * #CartDeliveryOptions へ移動する。appendChild は DOM ノードの移動のため、
 * 描画済み React ルートの状態・イベントは維持される。
 *
 * 数量変更時の Section Rendering は .js-contents（小計）だけを差し替えるため、
 * 移設済みノードは再描画の影響を受けない。
 */
(function () {
  var SLOT_ID = 'CartDeliveryOptions';
  var WIDGET_CLASSES = [
    'calendarMaster__autoInstall',
    'calendarMaster__placementAutoInstall',
  ];

  function relocate() {
    var slot = document.getElementById(SLOT_ID);
    if (!slot) return true;
    var moved = false;
    WIDGET_CLASSES.forEach(function (cls) {
      var widget = document.getElementsByClassName(cls)[0];
      if (widget && !slot.contains(widget)) {
        slot.appendChild(widget);
        moved = true;
      }
    });
    return moved && slot.children.length === WIDGET_CLASSES.length;
  }

  if (relocate()) return;
  var observer = new MutationObserver(function () {
    if (relocate()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
